<template>
	<multi-select
		clearable
		item-divider
		min-height="32px"
		class="type-input new-survey-input"
		:prop="prop"
		:ref="reference"
		:style="`color:${$appColors.info}`"
		:options="options"
		:value="value"
		@input="selecting"
	>
		<template slot="tag" slot-scope="{ tag }">
			<span>{{tag[prop]}}</span>
		</template>
		<template slot="icon">
			<div class="menu-icon"
				:style="`border-top:7px solid ${$appColors.success}`"
			></div>
		</template>
		<template slot="menu" slot-scope="{ menuItem, selected }">
			<div
				:class="[
					'menu-item',
					{ 'menu-item-selected': selected },
				]"
				:style="`background-color:${selected ? $appColors.primary : 'transparent'};border-bottom:1px solid ${$appColors.gray} !important`"
			>
				<span
					class="menu-item-name"
				>{{menuItem.title}}</span>
			</div>
		</template>
	</multi-select>
</template>
<script>
import multiSelect from 'multiselect-dl';

function selecting(selected) {
	const argsObj = { selected, node: this.$refs[this.reference] };
	this.$emit('input', argsObj);
}

export default {
	name: 'multi-selector',
	components: {
		multiSelect,
	},
	methods: {
		selecting,
	},
	props: {
		label: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			required: true,
		},
		prop: {
			type: String,
			required: true,
		},
		reference: {
			type: String,
			required: true,
		},
		value: null,
	},
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/multi-selector.vue